module.exports = __webpack_public_path__ + "img/car.be5030ca.webp";